import React from 'react';
import { Button } from '@/components/ui/button';
import { MoreVertical, Plus } from 'lucide-react';

interface SectionHeaderProps {
  title: string;
  lastUpdated?: string;
  actionLabel?: string;
  onActionClick?: () => void;
  onMoreClick?: () => void;
  showAction?: boolean;
}
export default function CategoryHeader({
  title,
  lastUpdated,
  onActionClick,
  onMoreClick,
  showAction = true,
}: SectionHeaderProps) {
  return (
    <div className="w-full rounded-2xl px-6 py-4 bg-white ">
      <div className="flex items-center justify-between gap-4">
        <div className="flex flex-row">
          <h2 className="text-xl font-semibold text-[#1E0036]">{title}</h2>
        </div>

        <div className="flex items-center gap-10">
          {/* {/* {showAction && (
            <Button
              onClick={onActionClick}
              className="rounded-2xl px-4 py-2 flex items-center gap-2"
            >
              <Plus size={16} />
              {actionLabel}
            </Button>
          )} */}
          {/*{lastUpdated && (
            <span className="text-sm text-lightPurple mt-1">Last Updated: {lastUpdated}</span>
          )}
          <button onClick={onMoreClick} className="p-2 rounded-full hover:bg-gray-100 transition">
            <MoreVertical size={18} className="text-gray-600" />
          </button>*/}
        </div>
      </div>
    </div>
  );
}
